import styled from 'styled-components';
import { Grid } from '@mui/material';

export const breakpoint = {
  small: 0,
  medium: 600,
  large: 1024,
  extraLarge: 1216,
};

export const StyledButtonGrid = styled(Grid)`
  margin-top: 1em;
  text-align: center
`;
